var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgFilledFeedbackSuccess = function SvgFilledFeedbackSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 98,
    viewBox: "0 0 192 98",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 9,
    width: 80,
    height: 80,
    rx: 24,
    fill: "#E5F9F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 31c-9.941 0-18 8.059-18 18s8.059 18 18 18 18-8.059 18-18-8.059-18-18-18zM74 49c0-12.15 9.85-22 22-22s22 9.85 22 22-9.85 22-22 22-22-9.85-22-22zm32.414-7.414a2 2 0 010 2.828l-12 12a2 2 0 01-2.828 0l-6-6a2 2 0 112.828-2.828L93 52.172l10.586-10.586a2 2 0 012.828 0z",
    fill: "#00AE96"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkyIiBoZWlnaHQ9Ijk4IiB2aWV3Qm94PSIwIDAgMTkyIDk4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSI1NiIgeT0iOSIgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiByeD0iMjQiIGZpbGw9IiNFNUY5RjQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05NiAzMUM4Ni4wNTg5IDMxIDc4IDM5LjA1ODkgNzggNDlDNzggNTguOTQxMSA4Ni4wNTg5IDY3IDk2IDY3QzEwNS45NDEgNjcgMTE0IDU4Ljk0MTEgMTE0IDQ5QzExNCAzOS4wNTg5IDEwNS45NDEgMzEgOTYgMzFaTTc0IDQ5Qzc0IDM2Ljg0OTcgODMuODQ5NyAyNyA5NiAyN0MxMDguMTUgMjcgMTE4IDM2Ljg0OTcgMTE4IDQ5QzExOCA2MS4xNTAzIDEwOC4xNSA3MSA5NiA3MUM4My44NDk3IDcxIDc0IDYxLjE1MDMgNzQgNDlaTTEwNi40MTQgNDEuNTg1OEMxMDcuMTk1IDQyLjM2NjggMTA3LjE5NSA0My42MzMyIDEwNi40MTQgNDQuNDE0Mkw5NC40MTQyIDU2LjQxNDJDOTMuNjMzMiA1Ny4xOTUzIDkyLjM2NjggNTcuMTk1MyA5MS41ODU4IDU2LjQxNDJMODUuNTg1OCA1MC40MTQyQzg0LjgwNDcgNDkuNjMzMiA4NC44MDQ3IDQ4LjM2NjggODUuNTg1OCA0Ny41ODU4Qzg2LjM2NjggNDYuODA0NyA4Ny42MzMyIDQ2LjgwNDcgODguNDE0MiA0Ny41ODU4TDkzIDUyLjE3MTZMMTAzLjU4NiA0MS41ODU4QzEwNC4zNjcgNDAuODA0NyAxMDUuNjMzIDQwLjgwNDcgMTA2LjQxNCA0MS41ODU4WiIgZmlsbD0iIzAwQUU5NiIvPgo8L3N2Zz4K";
export { SvgFilledFeedbackSuccess as ReactComponent };